import React from 'react';
import Icon from '../../../../components/common/Icon/Icon';
import { toYouTubeEmbedUrl } from '../../../../utils/youtubeEmbed';
import styles from './ExerciseYouTubePlayer.module.css';

interface ExerciseYouTubePlayerProps {
  videoUrl?: string | null;
  title: string;
  emptyMessage?: string;
}

const ExerciseYouTubePlayer: React.FC<ExerciseYouTubePlayerProps> = ({
  videoUrl,
  title,
  emptyMessage = 'Este exercício ainda não tem um vídeo cadastrado.',
}) => {
  const embedUrl = toYouTubeEmbedUrl(videoUrl);

  if (!embedUrl) {
    return (
      <div className={styles.empty}>
        <Icon name="play_circle" size={32} />
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={styles.player}>
      <iframe
        key={embedUrl}
        className={styles.iframe}
        src={embedUrl}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
};

export default ExerciseYouTubePlayer;
